import { render } from "./BaseCard.vue?vue&type=template&id=f03aff10&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=f03aff10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03aff10"]])

export default __exports__